export default "__VITE_ASSET__DY4pl8si__"